import { render } from "./AutocompleteCompany.vue?vue&type=template&id=496c9f7b"
import script from "./AutocompleteCompany.vue?vue&type=script&lang=js"
export * from "./AutocompleteCompany.vue?vue&type=script&lang=js"

import exportComponent from "/home/douglas/Documents/Rwi/surefooted-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__